export default {

    setCatalog (state, articles) {
      state.all = articles
      state.initialized = true
      state.page = 1
    },

    setCount(state, count) {
      state.count = count
    },

    setNextArticles (state, articles) {    
      state.all = [ ...state.all, ...articles ]
      state.page++
    }
}